import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppConfigService } from '@mds/angular-core-material';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ErrorType } from '../models/error-type.model';
import { HttpErrorResponseHandlerService } from '../services/http-error-response-handler.service';
import { TokenAuthService } from '../services/token-auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private tokenAuthService: TokenAuthService,
    private httpErrorResponseHandler: HttpErrorResponseHandlerService,
    private appConfigService: AppConfigService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.appConfigService.isInitialized$.pipe(
      switchMap(() => this.tokenAuthService.createToken(next)),
      catchError((errorResponse) => {
        if (errorResponse === ErrorType.NoToken) {
          this.router.navigate(['/404'], { skipLocationChange: true });
        } else {
          this.httpErrorResponseHandler.handle(errorResponse);
        }

        return of(false);
      })
    );
  }
}
